import React from "react";
import {
  Linking,
  StyleSheet,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Switch,
} from "react-native";
import CallIcon from "@assets/svg/CircleCall";
import color from "@constants/color";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import Text from "@components/CustomText";
import NoBag from "@assets/svg/NoBag";
import Tag from "@components/Tag";

const UserCard = ({
  item,
  onToggleUserSwitch = () => { },
  isToggleOn = false,
}) => {
  const openMapHandler = (lat, lng) => async () => {
    const url = `google.navigation:q=${lat},${lng}`;
    Linking.canOpenURL(url).then((supported) => {
      if (supported) return Linking.openURL(url);
      else {
        const browser_url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
        return Linking.openURL(browser_url);
      }
    });
  };

  const callCustomer = (phoneNumber) => {
    handleCallButtonPress(phoneNumber);
  };

  const itemBags = item?.bag_names || [];

  return (
    <View style={styles.container}>
      <View style={styles.rowContainer}>
        <View style={styles.bagContainer}>
          {item?.show_no_bag_icon ? (
            <NoBag height={32} width={27} />
          ) : (
            itemBags?.map((i, index) => (
              <Text
                variant="heading_24"
                numberOfLines={1}
                style={[
                  styles.bagText,
                  index === itemBags.length - 1 && styles.bagTextLast,
                ]}
              >
                {index === itemBags.length - 1 ? i : `${i}, `}
              </Text>
            ))
          )}
        </View>
        <View>
          {item?.is_priority_cx && (
            <View style={{ marginBottom: 4 }}>
              <Tag text="Priority" bgcolor="rgba(66, 116, 234, 1)" />
            </View>
          )}
          {!item?.enable_ofd ? (
            <View
              style={[
                styles.ofdContainer,
                { backgroundColor: "rgba(255, 77, 79, 0.05)", flex: 1 },
              ]}
            >
              <Text variant="caption_1" style={{ color: color.plain_red }}>
                {item?.disabled_reason}
              </Text>
            </View>
          ) : !item?.is_ofd ? (
            <Switch
              trackColor={{
                false: color.darkGrey,
                true: "rgba(193, 232, 173, 1)",
              }}
              thumbColor={isToggleOn ? color.plain_green : color.white}
              onValueChange={() => onToggleUserSwitch(item)}
              value={isToggleOn}
            />
          ) : (
            <View style={styles.ofdContainer}>
              <Text variant="caption_1" style={{ color: color.plain_green }}>
                OFD Marked
              </Text>
            </View>
          )}
        </View>
      </View>
      {item?.disabled_type === "PACKING" ? (
        <Text variant="heading_24" style={styles.notBaggedText}>
          Not Bagged!
        </Text>
      ) : null}
      <View style={styles.divider} />
      <View style={styles.rowContainer}>
        <Text variant="body_text_2" style={styles.userName}>
          {item.user_name}
        </Text>
        <TouchableWithoutFeedback
          onPress={() => callCustomer(item?.user_phone)}
        >
          <CallIcon />
        </TouchableWithoutFeedback>
      </View>
      <TouchableOpacity
        testID="cpdr-open-map"
        disabled={!(item?.user_lat && item?.user_lng)}
        onPress={openMapHandler(item?.user_lat, item?.user_lng)}
      >
        <Text
          style={[
            styles.addressText,
            item?.user_lat &&
            item?.user_lng && {
              color: "#4274EA",
              textDecorationLine: "underline",
            },
          ]}
        >
          {item.user_address}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default UserCard;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    padding: 16,
    margin: 16,
    marginVertical: 8,
    borderRadius: 12,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bagContainer: {
    flexDirection: "row",
    alignItems: "center",
    width: "60%",
    flexWrap: "wrap",
  },
  bagText: {
    color: color.mediumBlack,
  },
  bagTextLast: {
    marginRight: 0,
  },
  ofdContainer: {
    backgroundColor: "rgba(236, 252, 229, 1)",
    borderRadius: 14,
    paddingHorizontal: 10,
    paddingBottom: 2,
    justifyContent: "center",
    alignItems: "center"
  },
  notBaggedText: {
    color: color.plain_red,
    fontSize: 24,
  },
  divider: {
    backgroundColor: color.lighterBlack,
    height: 1,
    width: "100%",
    marginVertical: 8,
  },
  userName: {
    flex: 1,
    color: color.mediumBlack,
  },
  addressText: {
    color: color.mediumBlacklightBlack,
  },
});
